import {
  ApiResponse,
  AdSupplierGroupUser,
  PaginationResponse,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseAdSupplierGroupUsersParams {
  page?: number
  pageSize?: number
  ad_supplier_group_id?: number
  account?: string
}

export function useAdSupplierGroupUsers({
  page = 1,
  pageSize = 10,
  ad_supplier_group_id,
  account,
}: UseAdSupplierGroupUsersParams = {}) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<PaginationResponse<AdSupplierGroupUser>>>(
    token && ad_supplier_group_id
      ? `/api/ad-supplier-group-users?page=${page}&pageSize=${pageSize}&ad_supplier_group_id=${ad_supplier_group_id}${
          account ? `&account=${account}` : ''
        }`
      : null,
    undefined,
    token ?? '',
  )

  return {
    adSupplierGroupUsers: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
